import React, { Component } from 'react';
import { observer } from "mobx-react";
import { observable } from "mobx";

@observer class NavPane extends Component {

  @observable style = {};
  @observable visible = false;

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  setStyle(style) {
    this.style = style;
  }

  getStyle() {
    return {...this.style, ...{
      position: 'absolute',
      width: '15%',
      height: 'auto',
      boxShadow: '0px 0px 15px rgba(0, 0, 0, .5)',
      visibility: this.visible ? "visible" : "hidden"
    }}
  }

  render() {
    return (
      <div className="navPane" {...this.props} style={this.getStyle()}>
        {this.props.children}
      </div>
    );
  }

}

export default NavPane;



// WEBPACK FOOTER //
// ./src/components/ui/nav/NavPane.js